export default __webpack_public_path__ + "static/media/featSportMb.25de91d9.png";